import { render, staticRenderFns } from "./AuthLayoutComponent.vue?vue&type=template&id=5b48fc01&"
import script from "./AuthLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./AuthLayoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuthLayoutComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports